export default __webpack_public_path__ + "img/cNzeErlP.2f12fb2e.svg";